
export const admins = [
    {
        id: 1,
        label: 'module.dashboard',
        icon: 'fas fa-tachometer-alt',
        link: '/',
    },
    {
        id: 2,
        label: 'module.workplace',
        icon: 'fas fa-building',
        link: '/workplaces',
        subItems: [
            {
                id: 1,
                label: 'module.group',
                link: '/groups',
            },
            {
                id: 2,
                label: 'module.company',
                link: '/companies',
            },
            {
                id: 3,
                label: 'module.department',
                link: '/departments',
            },
            {
                id: 4,
                label: 'module.office',
                link: '/offices',
            },
            {
                id: 5,
                label: 'module.location',
                link: '/locations',
            },
            {
                id: 6,
                label: 'module.country',
                link: '/countries',
            },
            {
                id: 7,
                label: 'module.state',
                link: '/states',
            },
            {
                id: 8,
                label: 'module.companyType',
                link: '/company-types',
            },
            {
                id: 9,
                label: 'module.officeType',
                link: '/office-types',
            },
        ],
    },
    {
        id: 3,
        label: 'module.recruitment',
        icon: 'fas fa-user-plus',
        link: '/recruitments',
        subItems: [
            {
                id: 1,
                label: 'module.candidate',
                link: '/candidates',
            },
            {
                id: 2,
                label: 'module.job',
                link: '/candidate-jobs',
            },
            {
                id: 3,
                label: 'module.candidateStatus',
                link: '/candidate-statuses',
            },
            {
                id: 3,
                label: 'module.position',
                link: '/positions',
            },
        ],
    },
    {
        id: 4,
        label: 'module.orientation',
        icon: 'fas fa-graduation-cap',
        link: '/orientations',
        subItems: [
            {
                id: 1,
                label: 'module.module',
                link: '/orientation-modules',
            },
            {
                id: 2,
                label: 'module.assignment',
                link: '/orientation-module-assignments',
            },
            {
                id: 3,
                label: 'module.workgroup',
                link: '/workgroups',
            },
        ],
    },
    {
        id: 5,
        label: 'module.communication',
        icon: 'fas fa-bullhorn',
        link: '/communications',
        subItems: [
            {
                id: 1,
                label: 'module.report',
                link: '/reports',
            },
            {
                id: 2,
                label: 'module.article',
                link: '/articles',
            },
            {
                id: 3,
                label: 'module.event',
                link: '/events',
            },
            {
                id: 4,
                label: 'module.marketplace',
                link: '/marketplaces',
            },
            {
                id: 5,
                label: 'module.notification',
                link: '/notifications',
            },
            {
                id: 6,
                label: 'module.document',
                link: '/documents',
            },
            {
                id: 7,
                label: 'module.catalog',
                link: '/catalogs',
            },
            {
                id: 8,
                label: 'module.sportClub',
                link: '/sport-clubs',
            },
            {
                id: 9,
                label: 'module.privacyPolicy',
                link: '/privacy-policy',
                externalLink: true,
            },
            {
                id: 10,
                label: 'module.articleCategory',
                link: '/article-categories',
            },
            {
                id: 11,
                label: 'module.notificationIcon',
                link: '/notification-icons',
            },
            {
                id: 12,
                label: 'module.notificationChannel',
                link: '/notification-channels',
            },
            {
                id: 13,
                label: 'module.documentCategory',
                link: '/document-categories',
            },
            {
                id: 14,
                label: 'module.catalogCategory',
                link: '/catalog-categories',
            },
            {
                id: 15,
                label: 'module.catalogSubcategory',
                link: '/catalog-subcategories',
            },
        ],
    },
    {
        id: 6,
        label: 'module.meetingRoomManagement',
        icon: 'fas fa-door-open',
        link: '/meeting-room-management',
        subItems: [
            {
                id: 1,
                label: 'module.meetingRoom',
                link: '/meeting-rooms'
            },
            {
                id: 2,
                label: 'module.meetingRoomBooking',
                link: '/meeting-room-bookings'
            },
        ],
    },
    {
        id: 7,
        label: 'module.property',
        icon: 'fas fa-building',
        link: '/properties',
        subItems: [
            {
                id: 1,
                label: 'label.asset',
                link: '/property-assets',
            },
            {
                id: 2,
                label: 'label.tenanted',
                link: '/property-tenants',
            },
            {
                id: 3,
                label: 'label.assetRental',
                link: '/property-asset-rentals',
            },
            {
                id: 4,
                label: 'module.propertyStatus',
                link: '/property-statuses',
            },
            {
                id: 5,
                label: 'module.propertyAction',
                link: '/property-actions',
            },
            {
                id: 6,
                label: 'module.propertyAreaUnit',
                link: '/property-area-units',
            },
            {
                id: 7,
                label: 'module.propertyCategory',
                link: '/property-categories',
            },
            {
                id: 8,
                label: 'module.propertyTenure',
                link: '/property-tenures',
            },
            {
                id: 9,
                label: 'module.propertyType',
                link: '/property-types',
            },
        ],
    },
    {
        id: 8,
        label: 'module.vehicle',
        icon: 'fas fa-car',
        link: '/vehicles',
        subItems: [
            {
                id: 1,
                label: 'module.panel',
                link: '/panels'
            },
            {
                id: 2,
                label: 'module.panelType',
                link: '/panel-types'
            },
        ],
    },
    {
        id: 9,
        label: 'module.administration',
        icon: 'fas fa-user-shield',
        link: '/administrations',
        subItems: [
            {
                id: 1,
                label: 'module.user',
                link: '/users',
            },
            {
                id: 2,
                label: 'module.teamDirectory',
                link: '/team-directory',
                externalLink: true,
            },
        ],
    },
    {
        id: 10,
        label: 'module.system',
        icon: 'fas fa-cog',
        link: '/systems',
        subItems: [
            {
                id: 1,
                label: 'module.configuration',
                link: '/configurations',
            },
            {
                id: 2,
                label: 'module.diagnostics',
                link: '/diagnostics',
            },
        ],
    },
];

export const ihextars = [
    {
        id: 1,
        label: 'module.dashboard',
        icon: 'fas fa-tachometer-alt',
        link: '/',
    },
];
